import Constants from 'Constants'

export const DISPOSAL_TICKET_STATUS = {
  UNMATCHED: { value: 'UNMATCHED', label: 'Unprocessed', show: true },
  SUGGESTED: { value: 'SUGGESTED', label: 'Suggested match', show: false },
  MATCHED: { value: 'MATCHED', label: 'Matched', show: true },
  READY_FOR_INVOICE: { value: 'READY_FOR_INVOICE', label: 'Ready for invoice', show: false },
  INVOICED: { value: 'INVOICED', label: 'Invoiced', show: false },
  ALL: { value: 'ALL', label: 'All', show: true },
}

// dev mode limit is 2 days
// prod mode limit is 7 days
export const DATE_RANGE_INITIAL_LIMIT = Constants.DEV_MODE ? 1 : 6

// dev mode limit is 2 days
// prod mode limit is 31 days
export const DATE_RANGE_MAX_LIMIT = Constants.DEV_MODE ? 1 : 30

export const SHOW_READY_FOR_INVOICE_BUTTON = false

export const PANEL_MIN_SIZE = 30